<template>
  <div>
    <span v-if="loaded">
      <div v-if="copy">
        <label class="indicatorLabel">{{ $t('selecione-um-indicador') }}</label>
        <b-form-select
          class="indicator-select input-pentagro"
          v-model="singleSelection"
          :options="this.options"
          id="TreeSelected"
        ></b-form-select>
      </div>

      <div v-else>
        <label class="indicatorLabel">{{ $t('selecione-ao-menos-um-indicador') }}</label>
        <b-table
          class="table"
          :items="indicators"
          :fields="fields"
          select-mode="multi"
          responsive="sm"
          ref="selectableTable"
          selectable
          @row-selected="onRowSelected"
        >
        </b-table>
        <div v-if="selected.length > 0">
          <p class="mb-1">{{ $t('linhas-selecionadas') }}</p>
          <div class="field-selected">
            <span class="lines-selected" v-for="(item, i) in selected" :key="i">
              {{ item.Indicador }}
              <strong
                class="btn-clear"
                :title="$t('remover-selecao')"
                @click="removeSelected(item)"
                >x</strong
              >
            </span>
          </div>
        </div>
      </div>
    </span>
    <p v-else>{{ $t('carregando-informacoes') }}</p>
  </div>
</template>

<script>
import { faultTreeMixin } from "../../mixins/faultTreeMixin";
import { urlMainAPI, defaultSuccess } from "@/global";
import axios from "axios";

export default {
  name: "FaulTreeSelected",

  mixins: [faultTreeMixin],

  props: ["sendTreeData", "reset"],

  data() {
    return {
      selected: [],
      singleSelection: null,
      rowSelected: {},
      copy: true,
      options: [],
      indicators: [],
      loaded: false,
    };
  },
  methods: {
    resetForm() {
      this.sendBkp++;
      this.reloadTree = true;

      setTimeout(() => {
        this.treeData = {};
        this.treeData = this.treeDataBkp;
        this.reloadTree = false;
        defaultSuccess(this.$t('arvore-restaurada-ao-ultimo-ponto-salvo'));
      }, 500);
    },

    removeSelected(item) {
      if (this.selected.length > 1) {
        let index = this.indicators.indexOf(item);
        this.$refs.selectableTable.unselectRow(index);
      }
    },

    resetModels() {
      this.copy = true;
      this.selected = [];
    },

    loadFaultTree() {
      axios
        .get(`${urlMainAPI}/getfaulttreeconfiguration`)
        .then((res) => {
          if (res.data) {
            this.indicators = this.formatIndicator(res.data.indicatorList);
            this.options = this.formatSelect(res.data.indicatorList);
            this.$emit("indicators", this.options)
            this.loaded = true;
          }
        })
        .catch(console.log);
    },

    formatSelect(data) {
      let newList = new Array();
      data.forEach((i) => {
        let hasData = newList.find(
          (n) => n.id == i.id && n.productionUnitId == i.productionUnitId
        );
        if (!hasData) {
          newList.push({
            value: {
              id: i.id,
              productionUnitId: i.productionUnitId,
              system: i.system,
            },
            text: i.indicatorName,
          });
        }
      });
      this.singleSelection = newList[0].value;
      return newList;
    },
  },

  watch: {
    singleSelection(value) {
      this.resetModels();
      this.$emit("sendTreeData", value);
    },

    reset(value) {
      if (value) this.selected = [];
    },
  },

  created() {
    this.loadFaultTree();
  },
};
</script>

<style scoped>
.indicatorLabel {
  height: 17px;
  margin-top: 5px;
}

.indicator-select {
  height: 34px;
}

/*
.input-pentagro{
  height: 17px;
} */
/* .table,
.indicator-select,
.fault-tree {
  max-height: 155px;
  overflow-x: auto;
  border: 1px solid #00000013;
  border-radius: 4px;
  box-shadow: 2px 2px 2px #00000013;
}

.fault-tree {
  overflow-x: none;
  max-height: 600px;
  padding: 10px;
}

.indicator-select {
  margin-bottom: 15px;
}

img,
.copy {
  cursor: pointer;
  max-height: 35px;
}

.copy {
  height: 35px;
  width: 35px;
  color: #ff7100;
  transition-delay: 600ms;
}

.field-selected {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 15px;
  max-height: 100px;
  overflow-y: auto;
}

.lines-selected {
  background-color: #00000013;
  padding: 0 3px;
  margin: 2px 5px;
  border-radius: 3px;
} */
</style>